import { toNumber } from "lodash";
import { useSearchParams } from "react-router";

export type Sort = {
  key: string;
  direction: "asc" | "desc";
};

export const useSortAndPagination = ({
  initialPage = 1,
  initialLimit = 15,
  initialSort = { key: "name", direction: "asc" },
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getPage = () => toNumber(searchParams.get("page") || initialPage);
  const getLimit = () => toNumber(searchParams.get("limit") || initialLimit);
  const getSort = (): Sort => {
    const sortKey = searchParams.get("sortKey") || initialSort?.key;
    const sortDirection =
      searchParams.get("sortDirection") || initialSort?.direction;
    return { key: sortKey, direction: sortDirection as "asc" | "desc" };
  };

  const handlePageChange = (newPage: number) => {
    setSearchParams((prev) => {
      prev.set("page", String(newPage));
      return prev;
    });
  };

  const handleLimitChange = (newLimit: number) => {
    setSearchParams((prev) => {
      prev.set("page", "1");
      prev.set("limit", String(newLimit));
      return prev;
    });
  };

  const handleSortChange = (newSort: Sort) => {
    setSearchParams((prev) => {
      prev.set("sortKey", newSort.key);
      prev.set("sortDirection", newSort.direction);
      return prev;
    });
  };

  return {
    page: getPage(),
    limit: getLimit(),
    sort: getSort(),
    handleSortChange,
    handlePageChange,
    handleLimitChange,
  };
};
